
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/deals",
      function () {
        return require("private-next-pages/[lang]/deals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/deals"])
      });
    }
  